import IMemo from "../../../Sections/ElementsSections/Forms/Components/IMemo";
import TicketsClosingDetailPanel from "./TicketsClosingDetailPanel";
import { Feedback } from "./TicketsList";
import React from "react";
import SmetaTabs from "../../../Tools/Tabs/SmetaTabs";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";

interface TicketsListDetailsProps {
  description: string;
  solution: string;
  status: string;
  sendTaskFeedback: (feedback: Feedback) => void;
}

export default function TicketsListDetails({
  description,
  solution,
  status,
  sendTaskFeedback,
}: TicketsListDetailsProps) {
  return (
    <SmetaTabs id="supportRequestForm" style={{ width: "100%", height: "100%" }}>
      <SmetaTabItem
        id="Description"
        label="Описание"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <IMemo
          Text={description}
          readOnly={true}
          style={{
            height: "100%",
            width: "100%",
            resize: "none",
            overflow: "auto",
            outline: "none",
          }}
        />
      </SmetaTabItem>
      <SmetaTabItem
        id="Solution"
        label="Решение"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <IMemo
          Text={solution}
          readOnly={true}
          style={{
            height: "100%",
            width: "100%",
            resize: "none",
            overflow: "auto",
            outline: "none",
          }}
        />
      </SmetaTabItem>
      <SmetaTabItem
        id="Closing"
        label="Закрытие"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          display: "inline-block",
        }}
      >
        <TicketsClosingDetailPanel status={status} sendTaskFeedback={sendTaskFeedback} />
      </SmetaTabItem>
    </SmetaTabs>
  );
}
